export const tabsNavShowFunc = (item) => {
    const tabsWrapItem = item.closest('.swiper-tabs-wrap__item');
    tabsWrapItem.classList.toggle('open-show');
};